import React from 'react';
import { PitchChart as NYYPitchChart } from 'yankees-react-utils';
import { usePitchVideoFn } from '../data';
import { VideoPlayerModal } from './VideoPlayer';

const PitchChart = (props) => {
    const pitchVideoFn = usePitchVideoFn();
    return (
        <NYYPitchChart pitchVideoFn={pitchVideoFn} videoPlayerModal={VideoPlayerModal} {...props} />
    );
};

export default PitchChart;
